import { InfoRounded } from '@mui/icons-material';
import './styles.scss';

import { Text, Button } from "@fragments";





export default function InfoBlock({ title, description, ctaText, ctaUrl, ...props }) {
    return (
        <div {...props} className={`info-block-container ${props.className}`}>
            <div className="info-block-header">
                <Text.h4
                    left={<InfoRounded className='csf-6' />}
                    weight={400}
                    className="csf-6">
                    {title}
                </Text.h4>
                <Text.span className="csf-6 subtitle">
                    {description}
                </Text.span>
            </div>
            {
                ctaText && ctaUrl && (
                    <Button
                        text={ctaText}
                        href={ctaUrl}
                        color="overlay"
                        size="small"
                    />
                )
            }
        </div>
    );
}